import type {
  ProductionDataSource,
  WellProductionDataSources,
} from 'types/api-responses';

/** The sources offered when a well's daily production is unknown or can't be read. */
export const IHS_ONLY_SOURCES: WellProductionDataSources = {
  availableSources: ['ihs'],
  defaultSource: 'ihs',
};

/** Every production data source, in the order a picker lists them. */
export const PRODUCTION_DATA_SOURCES: ProductionDataSource[] = ['ihs', 'scada'];

/** The name users see for each production data source. */
export const PRODUCTION_DATA_SOURCE_LABELS: Record<
  ProductionDataSource,
  string
> = {
  ihs: 'IHS',
  scada: 'Operator',
};

/**
 * Whether a source's production is daily rather than monthly.
 *
 * @param {ProductionDataSource} source - The source to check.
 * @return {boolean} True for a daily source.
 */
export const isDailyProductionSource = (source: ProductionDataSource) =>
  source === 'scada';
